import { type CSSProperties, useCallback } from 'react';

export const useGetEventTitleStyle = () =>
  useCallback(
    ({ titleRows }: { titleRows: number }): CSSProperties | undefined =>
      titleRows > 1
        ? {
            lineClamp: titleRows,
            WebkitLineClamp: titleRows,
          }
        : undefined,
    [],
  );
